// src/pages/NotFound.js
import { Link, useLocation } from "react-router-dom";
import { m } from "framer-motion";

export default function NotFound() {
  const { pathname, search, hash } = useLocation();
  const tried = `${pathname}${search}${hash}` || "/";

  return (
    <main className="min-h-[60vh] grid place-items-center px-6 py-16 text-center">
      <m.div
        initial={{ opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.25, ease: "easeOut" }}
        className="max-w-2xl"
      >
        <p className="text-sm font-semibold tracking-wider text-slate-500">ERROR 404</p>

        <h1 className="mt-2 text-5xl sm:text-6xl font-extrabold tracking-tight
                       text-transparent bg-clip-text
                       bg-gradient-to-r from-red-600 via-slate-300 to-blue-600">
          Page not found
        </h1>

        {/* R/W/B underline accent */}
        <div className="mx-auto mt-4 h-1 w-36 rounded-full bg-gradient-to-r from-red-600 via-white to-blue-600" />

        <p className="mt-6 text-slate-600">
          We couldn’t find{" "}
          <code className="font-mono rounded bg-slate-100 px-2 py-1 text-slate-800">
            {tried}
          </code>
          . It may be broken or moved.
        </p>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 rounded-lg bg-blue-600 px-4 py-2 text-white
                       shadow hover:bg-blue-700 transition"
          >
            Go home
          </Link>

          <Link
            to="/companies"
            className="inline-flex items-center gap-2 rounded-lg border px-4 py-2
                       hover:bg-gray-50 transition"
          >
            View companies
          </Link>

        </div>

        {/* optional: back button */}
        <button
          onClick={() => window.history.back()}
          className="mt-4 inline-flex items-center gap-2 text-sm text-slate-500 hover:text-slate-700 underline underline-offset-4"
        >
          Go back
        </button>
      </m.div>
    </main>
  );
}
